export default function QuotePage() {
  return (
    <div className="min-h-screen bg-white">
      <div className="w-full px-4 md:px-6 lg:px-10 py-16">
        <h1 className="text-2xl font-bold text-ink-700">견적 요청하기</h1>
        <p className="text-sm text-ink-400 mt-2">선택한 제품과 후가공 옵션에 대한 견적을 요청하세요.</p>
      </div>
    </div>
  );
}